// ./pages/About/index.jsx
import React from "react";
import Checkoutcon from "../../components/Checkout";

import withAuth from "../../hoc/withAuth";

const Checkout = () => {
  return (
    <>
      <Checkoutcon/>
    </>
  );
};

export default withAuth(Checkout);


